import { Injectable } from '@angular/core';
import { EventsPage } from '@routes/events/models/event-model';

@Injectable()
export class EventPagingService {
  public page: EventsPage = {
    'pageNumber': 0,
    'size': 8,
    'eventsFilter': this.getFilter(),
    'eventsSortFilter': this.getSortFilter(),
    'ownerId': null,
    'sortProperty': '',
    'sortDirection': '',
    'searchValue': '',
    'totalElements': 0,
    'totalPages': 0,
    'tagIds': []
  };

  public setFilter(value: number) {
    localStorage.setItem('eventsFilter', value.toString());
  }

  public getFilter(): number {
      let value = parseInt(localStorage.getItem('eventsFilter'), 10);
      if (isNaN(value)) {
        value = 2;
      }

      return value;
  }

  public setSortFilter(value: number) {
    localStorage.setItem('eventsSortFilter', value.toString());
  }

  public getSortFilter(): number {
      let value = parseInt(localStorage.getItem('eventsSortFilter'), 10);
      if (isNaN(value)) {
          value = 6;
      }

      return value;
  }

}
